import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { QueryRankingToolConfigProvider } from '@empathyco/playboard-core-domain'
import type { interfaces } from 'inversify'
import type { Store } from 'vuex'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { TYPES } from '../config/inversify.types'
import { FeatureIdEnum } from '../enums'
import { CONFIG_CONSTS } from '../store/config/config.consts'

export function getQueryRankingToolConfigFromStoreProvider({
  container,
}: interfaces.Context): QueryRankingToolConfigProvider {
  return () => {
    const store = container.get<Store<unknown>>(TYPES.Store)
    const instance = store.getters[
      `${CONFIG_CONSTS.moduleName}/${CONFIG_CONSTS.getters.currentInstance}`
    ] as Instance
    const productsFieldName = instance?.catalog?.resultMappings.id ?? ''

    const attributesFieldNames =
      instance?.catalog?.fields.reduce<Array<string>>((result, field) => {
        if (field.rankable) {
          result.push(field.id)
        }
        return result
      }, []) ?? []

    const browseConfig = instance?.domains[DomainEnum.BROWSE]?.tools[FeatureIdEnum.CONFIGURATION]
    const browseFields = browseConfig?.useSearchConfigurations
      ? browseConfig?.attributes.map(attribute => ({
          id: attribute.id,
          displayName: attribute.prettyName,
          isCategory: attribute.isCategory,
        }))
      : undefined

    return {
      productsFieldName,
      attributesFieldNames,
      browseFields,
    }
  }
}
